import {
  askPunttNotificationPrefsSchema,
  type AskPunttNotificationPrefs,
} from "@mg/schemas/src/commons/askPunttNotificationPrefs";

export function shouldShowAskV2ReviewEmailNotificationCta(input: {
  chatId: string | null | undefined;
  emailReviewComplete: boolean | undefined;
  dismissedForChat: boolean;
  profileLoaded: boolean;
  /** True while a review is in flight (started, not yet finished). */
  reviewInProgress: boolean;
}): boolean {
  if (!input.profileLoaded || !input.chatId) return false;
  if (input.emailReviewComplete === true) return false;
  if (input.dismissedForChat) return false;
  if (!input.reviewInProgress) return false;
  return true;
}

export function mergeReviewEmailNotificationPrefEnabled(
  stored: Partial<AskPunttNotificationPrefs> | null | undefined,
): AskPunttNotificationPrefs {
  const current = askPunttNotificationPrefsSchema.parse(stored ?? {});
  return { ...current, emailReviewComplete: true };
}
